import {
  Component,
  ElementRef,
  ViewChild,
  input,
  output,
  signal
} from '@angular/core';
import { AppButtonComponent } from '@view/shared/molecules/button/button.component';
import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';

@Component({
  selector: 'app-upload-file-drop',
  imports: [AppButtonComponent, AppTranslationPipe],
  templateUrl: './upload-file-drop.component.html',
  styleUrl: './upload-file-drop.component.scss'
})
export class UploadFileDropComponent {
  @ViewChild('fileInput') private fileInputRef?: ElementRef<HTMLInputElement>;

  hasFile = input<boolean>(false);
  fileName = input<string | undefined>(undefined);
  fileSizeMB = input<string>('');
  isDisabled = input<boolean>(false);
  isUploadDisabled = input<boolean>(true);

  fileSelected = output<File | null>();
  remove = output<void>();
  upload = output<void>();

  readonly isDragging = signal(false);

  onFileUpload(event: Event): void {
    if (this.isDisabled()) {
      this.resetInput();
      return;
    }

    const file = (event.target as HTMLInputElement).files?.[0] ?? null;
    this.fileSelected.emit(file);
    if (!file) {
      this.resetInput();
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging.set(false);

    if (this.isDisabled()) {
      return;
    }

    const file = event.dataTransfer?.files?.[0] ?? null;
    this.fileSelected.emit(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();

    if (this.isDisabled()) {
      return;
    }

    this.isDragging.set(true);
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging.set(false);
  }

  onDragAreaKeydown(event: KeyboardEvent): void {
    if (['Enter', ' '].includes(event.key)) {
      event.preventDefault();

      if (this.isDisabled()) {
        return;
      }

      this.openFilePicker();
    }
  }

  onRemoveFile(): void {
    this.resetInput();
    this.remove.emit();
  }

  openFilePicker(): void {
    if (this.isDisabled()) {
      return;
    }

    this.fileInputRef?.nativeElement.click();
  }

  resetInput(): void {
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = '';
    }
  }
}
